
import {  Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectColumns, selectDataSource, selectloadStatus } from "./organisationSlice";
import { useEffect } from "react";
import { getOrganisations } from "./organisationThunk";




export default function Organisation() {
    const dispatch = useAppDispatch();
    
    const loadStatus = useAppSelector(selectloadStatus)
    const dataSource = useAppSelector(selectDataSource);
    const columns = useAppSelector(selectColumns);

    useEffect(()=> {
        dispatch(getOrganisations());
    },[]);

    return (<Table dataSource={dataSource} columns={columns} loading={loadStatus === 'loading'}/>)
}

